import API from "./API"

const endpoint = "practice-confirmations"
const groupEndpoint = "practice-confirmation-groups"

export const modifyEvidencingNotes = (params) =>
  API.post(`/${endpoint}/modify_notes/`, params);

export const fetchEvidencingGroups = ({ year, org_node_id }) =>
  API.get(`/${groupEndpoint}/fetch_evidencing_groups/?year=${year}&org_node_id=${org_node_id}`);

export const fetchEvidencingGroupData = (params) =>
  API.post(`/${endpoint}/fetch_evidencing_group_data/`, params);

export const fetchEvidencingGroupUploads = (params) =>
  API.post(`/${endpoint}/fetch_evidencing_group_uploads/`, params);

export const deleteEvidencingGroup = (params) =>
  API.post(`/${endpoint}/delete_evidencing_group/`, params);

export const updateEvidencingGroup = (params) =>
  API.post(`/${endpoint}/update_evidencing_group/`, params);

export const getEvidencingByOrg = (params) =>
  API.post(`/${endpoint}/get_evidencing_by_org/`, params);

// the aggregation evidencing for one supply input grouping, scoped to the field supply that
// grouping carries -- same row shape as getEvidencingByOrg
export const getEvidencingByAggregationLink = (params) =>
  API.post(`/${endpoint}/get_evidencing_by_aggregation_link/`, params);

export const createEvidencingUploadReview = (params) =>
  API.post(`/${endpoint}/create_evidencing_upload_review/`, params);

export const createEvidencingMessage = (params) =>
  API.post(`${endpoint}/create_evidencing_message/`, params);

export const modifyUploadEvidencingRelationships = (params) =>
  API.post(`${endpoint}/modify_upload_evidencing_relationships/`, params);

export const registerAttestationOnlyEvidencing = (params) =>
  API.post(`${endpoint}/register_attestation_only_evidencing/`, params);

//
// deprecated
//
export const getEvidencingByFieldIds = (params) =>
  API.post(`/${endpoint}/get_evidencing_by_field_ids/`, params);

export const fetchFieldCrops = (params) =>
  API.post(`/${endpoint}/fetch_field_crops/`, params);

export const createClientBasedGroups = (params) =>
  API.post(`/${endpoint}/create_client_based_evidencing_groups/`, params);
